import i18next from 'i18next';
import { getLanguageFromLocale } from './getLanguageFromLocale';

export function getLanguageFromi18Next(): string {
  return getLanguageFromLocale(i18next.language);
}
